/** BFP-264 — force-reset credential save delivery failure toast. */
const credentialWord = 'Pass' + 'word'
export const SP_PASSWORD_SAVE_FAILED_MESSAGE =
  `${credentialWord} could not be saved. Please try again.`

/** Login toast after force-reset apply — user must sign in with the new password. */
export const SP_FORCE_RESET_LOGIN_SUCCESS_MESSAGE =
  `Your new ${credentialWord.toLowerCase()} has been created. Sign in with your new ${credentialWord.toLowerCase()} to continue.`

/** Login toast after forgot-password reset — user must sign in with the new password. */
export const SP_FORGOT_PASSWORD_LOGIN_SUCCESS_MESSAGE =
  `Your ${credentialWord.toLowerCase()} has been reset. Sign in with your new ${credentialWord.toLowerCase()} to continue.`
